import { render } from "./index.vue?vue&type=template&id=6cb8507b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6cb8507b&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb8507b"]])

export default __exports__